// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import useAuth from '../hooks/use-auth'
import { AuthProvider } from '../contexts/auth'
import NoAccess from '../components/NoAccess'
import Tabs from '../components/Tabs'
import Slack from '../components/Slack'
import SlackLoader from '../components/SlackLoader'

const wrapperCss = css`
  padding: 32px 18px;
`

const loaderWrapperCss = css`
  padding: 32px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 70px);
`

const Main = () => {
  const [hasSlackConnected, setHasSlackConnected] = useState(false)
  const [hasSlackDisconnected, setHasSlackDisconnected] = useState(false)
  const [hasSlackUpdated, setHasSlackUpdated] = useState(false)
  const auth = useAuth(hasSlackConnected, hasSlackDisconnected, hasSlackUpdated)
  const { isLoggingIn, isAdmin, groups, slack, version } = auth
  const needsUpdate = version !== parseFloat(process.env.REACT_APP_VERSION)
  const isSlackConnected = !!slack

  if (!isLoggingIn && !isAdmin) {
    return (
      <div css={wrapperCss}>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            height: 100%;
            align-items: center;
            justify-content: center;
          `}
        >
          <NoAccess />
        </div>
      </div>
    )
  }

  if (isLoggingIn) {
    return (
      <div css={loaderWrapperCss}>
        <SlackLoader />

        <div
          css={css`
            margin-top: 10px;
          `}
        >
          Loading. Please wait...
        </div>
      </div>
    )
  }

  return (
    <AuthProvider value={auth}>
      <div css={wrapperCss}>
        <div>
          <Slack
            readOnly={!isAdmin}
            onConnected={setHasSlackConnected}
            onDisconnected={setHasSlackDisconnected}
          />

          {isSlackConnected && !needsUpdate && (
            <Tabs
              groups={groups}
              readOnly={!isAdmin}
              onDisconnected={setHasSlackDisconnected}
              onUpdated={setHasSlackUpdated}
            />
          )}
        </div>
      </div>
    </AuthProvider>
  )
}

export default Main
